/* eslint-disable max-len */
export const landing = {
  'answer-on-questions': 'Суроолорго жооп бериңиз',
  'candidate-page-title': 'Талапкердин анкетасы',
  'choose-vacancy': 'Вакансияны тандаңыз',
  'data-processing-and-agreement-links': 'Мен жумушка ыктымалдуу орношуу максатында <a href="/pd_processing_policy_kg.pdf" class="text-primary-100" target="_blank">жеке маалыматымды иштеп чыгууга</a> макулдугумду берем жана <a href="/user_agreement_sm_podbor_kg.pdf" class="text-primary-100" target="_blank">Колдонуучулук келишимди</a> кабыл алам',
  'do-you-lead-a-healthy-lifestyle': 'Сергек жашоо образын карманасызбы?',
  'do-you-play-sport': 'Спорт менен машыгасызбы?',
  'type-full-name': 'Аты-жөнүңүздү киргизиңиз',
  'type-first-name': 'Атын териңиз',
  'type-last-name': 'Фамилиясын териңиз',
  'type-patronymic-name': 'Атасынын атын киргизиңиз',
  'full-name': 'Аты-жөнү',
  'error:birthday': 'Туулган күнүңүздү тандаңыз',
  'error:citizenship': 'Жарандыгыңызды тандаңыз',
  'error:city': 'Шаарды тандаңыз',
  'error:email': 'E-mail дарегиңизди жазыңыз',
  'error:correct-email': 'E-mail дарегиңизди жазыңыз',
  'error:type-full-name': 'Фамилияңызды, атыңызды жана атаңыздын атын бош орундар менен бөлүп, аты-жөнүңүздү жазыңыз',
  'error:type-first-name': 'Атын териңиз',
  'error:type-last-name': 'Фамилиясын териңиз',
  'error:type-patronymic-name': 'Атасынын атын киргизиңиз',
  'error:expected-income-level': 'Күткөн киреше деңгээлин жазыңыз',
  'error:phone': 'Телефонуңузду жазыңыз',
  'error:phone-number': 'Телефонуңузду жазыңыз',
  'error:prefered-communication-method': 'Ыңгайлуу байланыш ыкмасын тандаңыз',
  'error:prefered-schedule': 'Графикти тандаңыз',
  'error:store': 'Дүкөндү тандаңыз',
  'error:recommender-city': 'Шаарды киргизиңиз',
  'expected-income-level': 'Күтүлгөн киреше деңгээли, сом менен',
  'fill-personal-data': 'Жеке маалыматыңызды толтуруңуз',
  'fill-required-fields': 'Милдеттүү талааларды толтуруңуз!',
  'for-example-basketball': 'Мисалы, баскетбол',
  'generating-telegram-link-please-wait': 'Telegram-ботко шилтеме түзүлүүдө. Баракчадан чыгып кетпеңиз, бир нече секунд талап кылынышы мүмкүн.',
  'go-to-telegram': 'Telegramга өтүү',
  'if-you-have-trouble-to-fill-form': 'Анкетаны толтурууда кыйынчылык жаралса, 8 800 350 80 60 номерине чалыңыз',
  'if-you-have-trouble-to-fill-form-email': `Анкетаны толтурууда кыйынчылык жаралса, бизге жазыңыз
    <a href="mailto:Support_smpodbor@sportmaster.com">Support_smpodbor@sportmaster.com</a>`,
  'full-name-exemplicant': 'Асанов Асан Асанович',
  'first-name-exemplicant': 'Асан',
  'last-name-exemplicant': 'Асанов',
  'patronymic-name-exemplicant': 'Асанович',
  'link-our-telegram-for-more-info': 'Жумуш маегинин кийинки баскычтары жөнүндө маалыматты тезирээк алуу үчүн биздин <a :href="telegramLink" class="text-primary-100" target="_blank">Telegramга</a> өтүңүз',
  'online-stage-personal-link-email': 'Онлайн-баскычтан өтүү үчүн почтаңызга жеке шилтеме жөнөтүлөт.',
  'online-stage-video-recording-agreement': 'Мен онлайн-баскычтан өтүү учурунда видео жаздырууга макулдугумду берем.',
  'phone-number': 'Телефон номери',
  'prefered-communication-method': 'Ыңгайлуу байланыш ыкмасы',
  'prefered-schedule': 'Каалаган график',
  'previous-step': 'Мурунку кадам',
  'profile-vk': 'VK профили',
  'questionnaire-sent-successfully': 'Анкета ийгиликтүү жиберилди',
  'online-stage-personal-link-sent-on-your-email': 'Сиздин <strong>{userEmail}</strong> почта дарегиңизге онлайн-баскычтан өтүү үчүн жеке шилтеме жөнөтүлдү',
  'sales-representative': 'Соода өкүлү',
  'system-administrator': 'Системдик администратор',
  'type-birthday': 'Туулган күнүңүздү жазыңыз',
  'type-profile-vk-link': 'VK профилиңизге шилтемени киргизиңиз',
  'write-what-sport-do-you-do': 'Мисалы, баскетбол',
  'fill-questionnaire': 'Анкетадагы маалыматты толтуруңуз',
  birthday: 'Туулган күнү',
  citizenship: 'Жарандыгы',
  city: 'Шаар',
  loader: 'Жүк ташуучу',
  next: 'Кийинки',
  partner: 'Өнөктөш',
  phone: 'Телефон',
  email: 'E-mail',
  step: 'Кадам',
  store: 'Дүкөн',
  ITN: 'СИН',
  MSRN: 'НМКН',
  code: 'Код',
  'send-questionnaire': 'Анкетаны жөнөтүү',
  'recommender-data-title': 'Сунуштоочунун маалыматтары',
  'has-work-in-this-company-before': 'Буга чейин Спортмастерде иштеген',
};
